import styled from 'styled-components';

interface ItemProps {
  readonly theme?: string;
  readonly inset?: string;
  readonly visible?: boolean;
}
export const ToolTipContainer = styled.div<ItemProps>`
  z-index: 998;
  position: fixed;
  background-color: rgba(62,70,78,0.75);
  border-radius: 4px;
  padding-bottom: 10px;
  width: 200px;
  color: white;
  height: fit-content;
  display: none;
  inset: ${props => props.inset? props.inset: '0'};
`;

export const ToolTipTitle = styled.div<ItemProps>`
  border-radius: 4px 4px 0 0;
  width:100%;
  height: 30px;
  font-size: 15px;
  font-weight: bold;
  color: #F7F8FA;
  display: flex;
  justify-content: center;
  align-items:center;
  background-color: rgba(62,70,78,0.75);
`;

